import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import {
  AUTOMATION_RUN_KEY,
  AUTOMATION_RUNS_KEY,
  AUTOMATION_RUNS_WITH_DATASETS_KEY,
} from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_run_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { SimpleResponse } from '@/types/common.ts';

type UpdateRunParams = {
  name?: string;
};

const useUpdateRun = (
  runId: string,
): UseMutationResult<SimpleResponse, AxiosError, UpdateRunParams> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const automationId = useAutomationId();

  return useMutation({
    mutationFn: async (params: UpdateRunParams) => {
      const response = await apiClient.put(get_run_url(runId), params);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: AUTOMATION_RUNS_KEY(automationId) });
      await queryClient.invalidateQueries({ queryKey: AUTOMATION_RUN_KEY(automationId, runId) });
      await queryClient.invalidateQueries({
        queryKey: AUTOMATION_RUNS_WITH_DATASETS_KEY(automationId),
      });
    },
  });
};

export default useUpdateRun;
